import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import('../views/Index.vue')
  },
  {
    path: '/create',
    name: 'Create',
    component: () => import('../views/Create.vue')
  },
  {
    path: '/research',
    name: 'Research',
    component: () => import('../views/Research.vue')
  },
  {
    path: '/research-report/:id',
    name: 'ResearchReportDetail',
    component: () => import('../views/ResearchReportDetail.vue'),
    meta: { titleKey: 'researchReport.pageTitle' }
  },
  {
    path: '/plaza',
    name: 'Plaza',
    component: () => import('../views/Plaza.vue')
  },
  {
    path: '/influence',
    name: 'Influence',
    component: () => import('../views/Influence.vue')
  },
  {
    path: '/chat',
    name: 'Chat',
    component: () => import('../views/ChatWrapper.vue')
  },
  {
    path: '/about',
    name: 'AboutHeymaster',
    component: () => import('../views/AboutHeymaster.vue')
  },
  {
    path: '/virtual-person',
    name: 'VirtualPerson',
    component: () => import('../views/VirtualPerson.vue')
  },
  {
    path: '/services',
    name: 'Services',
    component: () => import('../views/Services.vue')
  },
  {
    path: '/affiliate',
    name: 'Affiliate',
    component: () => import('../views/Affiliate.vue')
  },
  {
    path: '/terms',
    name: 'Terms',
    component: () => import('../views/Terms.vue')
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('../views/Privacy.vue')
  },
  {
    path: '/pricing',
    name: 'Pricing',
    component: () => import('../views/pricing.vue')
  },
  {
    path: '/solution',
    name: 'Solution',
    component: () => import('../views/Solution.vue')
  },
  {
    path: '/forum',
    name: 'Forum',
    component: () => import('../views/forum/ForumList.vue'),
    meta: { titleKey: 'route.forum.list' }
  },
  {
    path: '/forum/create',
    name: 'ForumCreate',
    component: () => import('../views/forum/ForumEdit.vue'),
    meta: { titleKey: 'route.forum.create', requireAuth: true }
  },
  {
    path: '/forum/edit/:id',
    name: 'ForumEditPost',
    component: () => import('../views/forum/ForumEdit.vue'),
    meta: { titleKey: 'route.forum.edit', requireAuth: true }
  },
  {
    path: '/forum/:id',
    name: 'ForumDetail',
    component: () => import('../views/forum/ForumDetail.vue'),
    meta: { titleKey: 'route.forum.detail' }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue')
  },
  {
    path: '/payment/success',
    name: 'PaymentSuccess',
    component: () => import('../views/PaymentSuccess.vue')
  },
  {
    path: '/payment/cancel',
    name: 'PaymentCancel',
    component: () => import('../views/PaymentCancel.vue')
  },
  {
    path: '/user',
    component: () => import('../views/user/Layout.vue'),
    redirect: '/user/dashboard',
    children: [
      { path: 'dashboard', name: 'UserDashboard', component: () => import('../views/user/Dashboard.vue') },
      { path: 'chats', name: 'UserChats', component: () => import('../views/user/MyChats.vue') },
      { path: 'predictions', name: 'UserPredictions', component: () => import('../views/user/MyPredictions.vue') },
      { path: 'favorites', name: 'UserFavorites', component: () => import('../views/user/MyFavorites.vue') },
      { path: 'settings', name: 'UserSettings', component: () => import('../views/user/Settings.vue') }
    ]
  }
]

const router = new VueRouter({
  // Hash 模式：地址为 /#/path，静态部署下刷新不依赖服务端 rewrite
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
